import util from '../../lib/util';
import {workingSet} from './mergeContext';
import store from '../store';
import Actions from '../actions/indexExport';
import {getCurrentUserId} from '../../lib/picos/currentLogin';
import newHRTimestamp from '../../lib/picos/timestamp';
import {findAll} from '../find';
import Contact from '../../entities/contact';
import Matter from '../../entities/matter';
import Conflict from '../../entities/conflict';
import Expense from '../../entities/expense';
import FlatFee from '../../entities/flatFee';
import Lead from '../../entities/lead';
import Participant from '../../entities/participant';
import Referral from '../../entities/referral';
import Task from '../../entities/task';
import Transaction from '../../entities/transaction';
import User from '../../entities/user';
import Document from '../../entities/document';
import Comment from '../../entities/comment';
import Identification from '../../entities/identification';
import Event from '../../entities/event';
export function deleteContact(contact: Contact, mergeId?: string) {
let targetImportSource = 'merge';
if (!mergeId) {targetImportSource = 'delete';mergeId = contact.id;}
const _work = workingSet();
[...store.getState().matters.getMappingFor('contactId', contact.id),
...store.getState().matters.getMappingFor('billToContactId', contact.id),].filter(matterTemp => matterTemp.status !== 'D').filter((matterTemp, i, all) => all.findIndex(o => o.id === matterTemp.id) === i).forEach(matterTemp => {
const _matter = ((_work.get('matter:' + matterTemp.id) ?? matterTemp) as Matter).clone();
_matter.status = 'U';
_matter.addedOn = newHRTimestamp();
_matter.addedBy = getCurrentUserId();
_matter.importSource = targetImportSource;
_matter.importId = mergeId;
_matter.clients = _matter.clients?.filter(id => id !== contact.id) || [];

if (_matter.billToContactId === contact.id) {
_matter.billToContactId = null;

}
_work.set('matter:' + _matter.id, _matter);
store.dispatch(Actions.MatterActions.saveMatterQueue(_matter));
});
store.getState().conflicts.getMappingFor('checkedContactIds', contact.id).filter(conflictTemp => conflictTemp.status !== 'D').forEach(conflictTemp => {
const _conflict = ((_work.get('conflict:' + conflictTemp.id) ?? conflictTemp) as Conflict).clone();
_conflict.status = 'U';
_conflict.addedOn = newHRTimestamp();
_conflict.addedBy = getCurrentUserId();
_conflict.importSource = targetImportSource;
_conflict.importId = mergeId;
_conflict.checkedContactIds = _conflict.checkedContactIds?.filter(id => id !== contact.id) || [];

_work.set('conflict:' + _conflict.id, _conflict);
store.dispatch(Actions.ConflictActions.saveConflictQueue(_conflict));
});
store.getState().contacts.getMappingFor('companyId', contact.id).filter(contactTemp => contactTemp.status !== 'D').forEach(contactTemp => {
const _contact = ((_work.get('contact:' + contactTemp.id) ?? contactTemp) as Contact).clone();
_contact.status = 'U';
_contact.addedOn = newHRTimestamp();
_contact.addedBy = getCurrentUserId();
_contact.importSource = targetImportSource;
_contact.importId = mergeId;
if (_contact.companyId === contact.id) {
_contact.companyId = null;

}
_work.set('contact:' + _contact.id, _contact);
store.dispatch(Actions.ContactActions.saveContactQueue(_contact));
});
store.getState().expenses.getMappingFor('payee', contact.id).filter(expenseTemp => expenseTemp.status !== 'D').forEach(expenseTemp => {
const _expense = ((_work.get('expense:' + expenseTemp.id) ?? expenseTemp) as Expense).clone();
_expense.status = 'U';
_expense.addedOn = newHRTimestamp();
_expense.addedBy = getCurrentUserId();
_expense.importSource = targetImportSource;
_expense.importId = mergeId;
if (_expense.payee === contact.id) {
_expense.payee = null;

}
_work.set('expense:' + _expense.id, _expense);
store.dispatch(Actions.ExpenseActions.saveExpenseQueue(_expense));
});
store.getState().flatFees.getMappingFor('relatedTo', contact.id).filter(flatFeeTemp => flatFeeTemp.status !== 'D').forEach(flatFeeTemp => {
const _flatFee = ((_work.get('flatFee:' + flatFeeTemp.id) ?? flatFeeTemp) as FlatFee).clone();
_flatFee.status = 'U';
_flatFee.addedOn = newHRTimestamp();
_flatFee.addedBy = getCurrentUserId();
_flatFee.importSource = targetImportSource;
_flatFee.importId = mergeId;
if (_flatFee.relatedTo === contact.id) {
_flatFee.relatedTo = null;

}
_work.set('flatFee:' + _flatFee.id, _flatFee);
store.dispatch(Actions.FlatFeeActions.saveFlatFeeQueue(_flatFee));
});
[...store.getState().leads.getMappingFor('clients', contact.id),
...store.getState().leads.getMappingFor('payers', contact.id),
...store.getState().leads.getMappingFor('referrers', contact.id),].filter(leadTemp => leadTemp.status !== 'D').filter((leadTemp, i, all) => all.findIndex(o => o.id === leadTemp.id) === i).forEach(leadTemp => {
const _lead = ((_work.get('lead:' + leadTemp.id) ?? leadTemp) as Lead).clone();
_lead.status = 'U';
_lead.addedOn = newHRTimestamp();
_lead.addedBy = getCurrentUserId();
_lead.importSource = targetImportSource;
_lead.importId = mergeId;
_lead.clients = _lead.clients?.filter(id => id !== contact.id) || [];

_lead.payers = _lead.payers?.filter(id => id !== contact.id) || [];

_lead.referrers = _lead.referrers?.filter(id => id !== contact.id) || [];

_work.set('lead:' + _lead.id, _lead);
store.dispatch(Actions.LeadActions.saveLeadQueue(_lead));
});
store.getState().participants.getMappingFor('contactId', contact.id).filter(participantTemp => participantTemp.status !== 'D').forEach(participantTemp => {
const _participant = ((_work.get('participant:' + participantTemp.id) ?? participantTemp) as Participant).clone();
_participant.status = 'U';
_participant.addedOn = newHRTimestamp();
_participant.addedBy = getCurrentUserId();
_participant.importSource = targetImportSource;
_participant.importId = mergeId;
if (_participant.contactId === contact.id) {
_participant.contactId = '';

}
_work.set('participant:' + _participant.id, _participant);
store.dispatch(Actions.ParticipantActions.saveParticipantQueue(_participant));
});
store.getState().referrals.getMappingFor('referee', contact.id).filter(referralTemp => referralTemp.status !== 'D').forEach(referralTemp => {
const _referral = ((_work.get('referral:' + referralTemp.id) ?? referralTemp) as Referral).clone();
_referral.status = 'U';
_referral.addedOn = newHRTimestamp();
_referral.addedBy = getCurrentUserId();
_referral.importSource = targetImportSource;
_referral.importId = mergeId;
if (_referral.referee === contact.id) {
_referral.referee = null;

}
_work.set('referral:' + _referral.id, _referral);
store.dispatch(Actions.ReferralActions.saveReferralQueue(_referral));
});
store.getState().tasks.getMappingFor('contactId', contact.id).filter(taskTemp => taskTemp.status !== 'D').forEach(taskTemp => {
const _task = ((_work.get('task:' + taskTemp.id) ?? taskTemp) as Task).clone();
_task.status = 'U';
_task.addedOn = newHRTimestamp();
_task.addedBy = getCurrentUserId();
_task.importSource = targetImportSource;
_task.importId = mergeId;
_task.relatedTo = _task.relatedTo?.filter(id => id !== contact.id) || [];

_work.set('task:' + _task.id, _task);
store.dispatch(Actions.TaskActions.saveTaskQueue(_task));
});
store.getState().transactions.getMappingFor('clientIds', contact.id).filter(transactionTemp => transactionTemp.status !== 'D').forEach(transactionTemp => {
const _transaction = ((_work.get('transaction:' + transactionTemp.id) ?? transactionTemp) as Transaction).clone();
_transaction.status = 'U';
_transaction.addedOn = newHRTimestamp();
_transaction.addedBy = getCurrentUserId();
_transaction.importSource = targetImportSource;
_transaction.importId = mergeId;
_transaction.clientIds = _transaction.clientIds?.filter(id => id !== contact.id) || [];

_work.set('transaction:' + _transaction.id, _transaction);
store.dispatch(Actions.TransactionActions.saveTransactionQueue(_transaction));
});
store.getState().users.getMappingFor('contactId', contact.id).filter(userTemp => userTemp.status !== 'D').forEach(userTemp => {
const _user = ((_work.get('user:' + userTemp.id) ?? userTemp) as User).clone();
_user.status = 'U';
_user.addedOn = newHRTimestamp();
_user.addedBy = getCurrentUserId();
_user.importSource = targetImportSource;
_user.importId = mergeId;
if (_user.contactId === contact.id) {
_user.contactId = null;

}
_work.set('user:' + _user.id, _user);
store.dispatch(Actions.UserActions.saveUserQueue(_user));
});
findAll<Transaction>('transactions').filter(transactionTemp => ['C','G'].includes(transactionTemp.sourceType || '') && transactionTemp.source === contact.id && transactionTemp.status !== 'D').forEach(transactionTemp => {
const _transaction = ((_work.get('transaction:' + transactionTemp.id) ?? transactionTemp) as Transaction).clone();

_transaction.status = 'U';
_transaction.addedOn = newHRTimestamp();
_transaction.addedBy = getCurrentUserId();
_transaction.importSource = targetImportSource;
_transaction.importId = mergeId;
_work.set('transaction:' + _transaction.id, _transaction);
store.dispatch(Actions.TransactionActions.saveTransactionQueue(_transaction));
});
findAll<Transaction>('transactions').filter(transactionTemp => ['C','G'].includes(transactionTemp.targetType || '') && transactionTemp.target === contact.id && transactionTemp.status !== 'D').forEach(transactionTemp => {
const _transaction = ((_work.get('transaction:' + transactionTemp.id) ?? transactionTemp) as Transaction).clone();

_transaction.status = 'U';
_transaction.addedOn = newHRTimestamp();
_transaction.addedBy = getCurrentUserId();
_transaction.importSource = targetImportSource;
_transaction.importId = mergeId;
_work.set('transaction:' + _transaction.id, _transaction);
store.dispatch(Actions.TransactionActions.saveTransactionQueue(_transaction));
});


contact.status = 'D';
contact.addedOn = newHRTimestamp();
contact.addedBy = getCurrentUserId();
contact.importSource = targetImportSource;
contact.importId = mergeId;
store.dispatch(Actions.ContactActions.removeContactQueue(contact));
findAll<Document>('documents').filter(documentTemp => documentTemp.entityType === 'contact' && documentTemp.entityId === contact.id && documentTemp.status !== 'D').forEach(documentTemp => {
const _document = ((_work.get('document:' + documentTemp.id) ?? documentTemp) as Document).clone();
_document.status = 'D';
_document.addedOn = newHRTimestamp();
_document.addedBy = getCurrentUserId();
_document.importSource = targetImportSource;
_document.importId = mergeId;
_work.set('document:' + _document.id, _document);
store.dispatch(Actions.DocumentActions.removeDocumentQueue(_document));
});
findAll<Comment>('comments').filter(commentTemp => commentTemp.entityType === 'contact' && commentTemp.entityId === contact.id && commentTemp.status !== 'D').forEach(commentTemp => {
const _comment = ((_work.get('comment:' + commentTemp.id) ?? commentTemp) as Comment).clone();
_comment.status = 'D';
_comment.addedOn = newHRTimestamp();
_comment.addedBy = getCurrentUserId();
_comment.importSource = targetImportSource;
_comment.importId = mergeId;
_work.set('comment:' + _comment.id, _comment);
store.dispatch(Actions.CommentActions.removeCommentQueue(_comment));
});
findAll<Identification>('identifications').filter(identificationTemp => identificationTemp.entityType === 'contact' && identificationTemp.entityId === contact.id && identificationTemp.status !== 'D').forEach(identificationTemp => {
const _identification = ((_work.get('identification:' + identificationTemp.id) ?? identificationTemp) as Identification).clone();
_identification.status = 'D';
_identification.addedOn = newHRTimestamp();
_identification.addedBy = getCurrentUserId();
_identification.importSource = targetImportSource;
_identification.importId = mergeId;
_work.set('identification:' + _identification.id, _identification);
store.dispatch(Actions.IdentificationActions.removeIdentificationQueue(_identification));
});
findAll<Event>('events').filter(eventTemp => eventTemp.entityType === 'contact' && eventTemp.entityId === contact.id && eventTemp.status !== 'D').forEach(eventTemp => {
const _event = ((_work.get('event:' + eventTemp.id) ?? eventTemp) as Event).clone();
_event.status = 'D';
_event.addedOn = newHRTimestamp();
_event.addedBy = getCurrentUserId();
_event.importSource = targetImportSource;
_event.importId = mergeId;
_work.set('event:' + _event.id, _event);
store.dispatch(Actions.EventActions.removeEventQueue(_event));
});
findAll<Participant>('participants').filter(participantTemp => participantTemp.entityType === 'contact' && participantTemp.entityId === contact.id && participantTemp.status !== 'D').forEach(participantTemp => {
const _participant = ((_work.get('participant:' + participantTemp.id) ?? participantTemp) as Participant).clone();
_participant.status = 'D';
_participant.addedOn = newHRTimestamp();
_participant.addedBy = getCurrentUserId();
_participant.importSource = targetImportSource;
_participant.importId = mergeId;
_work.set('participant:' + _participant.id, _participant);
store.dispatch(Actions.ParticipantActions.removeParticipantQueue(_participant));
});
}
export function replaceContact(contact: Contact, replaceWith: Contact, mergeId?: string) {
let targetImportSource = 'merge';
if (!mergeId) {targetImportSource = 'delete';mergeId = contact.id;}
const _work = workingSet();
[...store.getState().matters.getMappingFor('contactId', contact.id),
...store.getState().matters.getMappingFor('billToContactId', contact.id),].filter(matterTemp => matterTemp.status !== 'D').filter((matterTemp, i, all) => all.findIndex(o => o.id === matterTemp.id) === i).forEach(matterTemp => {
const _matter = ((_work.get('matter:' + matterTemp.id) ?? matterTemp) as Matter).clone();
_matter.status = 'U';
_matter.addedOn = newHRTimestamp();
_matter.addedBy = getCurrentUserId();
_matter.importSource = targetImportSource;
_matter.importId = mergeId;
_matter.clients = _matter.clients?.map(id => (id === contact.id) ? replaceWith.id : id) || [];

if (_matter.billToContactId === contact.id) {
_matter.billToContactId = replaceWith.id;

}
_work.set('matter:' + _matter.id, _matter);
store.dispatch(Actions.MatterActions.saveMatterQueue(_matter));
});
store.getState().conflicts.getMappingFor('checkedContactIds', contact.id).filter(conflictTemp => conflictTemp.status !== 'D').forEach(conflictTemp => {
const _conflict = ((_work.get('conflict:' + conflictTemp.id) ?? conflictTemp) as Conflict).clone();
_conflict.status = 'U';
_conflict.addedOn = newHRTimestamp();
_conflict.addedBy = getCurrentUserId();
_conflict.importSource = targetImportSource;
_conflict.importId = mergeId;
_conflict.checkedContactIds = _conflict.checkedContactIds?.map(id => (id === contact.id) ? replaceWith.id : id) || [];

_work.set('conflict:' + _conflict.id, _conflict);
store.dispatch(Actions.ConflictActions.saveConflictQueue(_conflict));
});
store.getState().contacts.getMappingFor('companyId', contact.id).filter(contactTemp => contactTemp.status !== 'D').forEach(contactTemp => {
const _contact = ((_work.get('contact:' + contactTemp.id) ?? contactTemp) as Contact).clone();
_contact.status = 'U';
_contact.addedOn = newHRTimestamp();
_contact.addedBy = getCurrentUserId();
_contact.importSource = targetImportSource;
_contact.importId = mergeId;
if (_contact.companyId === contact.id) {
_contact.companyId = replaceWith.id;

}
_work.set('contact:' + _contact.id, _contact);
store.dispatch(Actions.ContactActions.saveContactQueue(_contact));
});
store.getState().expenses.getMappingFor('payee', contact.id).filter(expenseTemp => expenseTemp.status !== 'D').forEach(expenseTemp => {
const _expense = ((_work.get('expense:' + expenseTemp.id) ?? expenseTemp) as Expense).clone();
_expense.status = 'U';
_expense.addedOn = newHRTimestamp();
_expense.addedBy = getCurrentUserId();
_expense.importSource = targetImportSource;
_expense.importId = mergeId;
if (_expense.payee === contact.id) {
_expense.payee = replaceWith.id;

}
_work.set('expense:' + _expense.id, _expense);
store.dispatch(Actions.ExpenseActions.saveExpenseQueue(_expense));
});
store.getState().flatFees.getMappingFor('relatedTo', contact.id).filter(flatFeeTemp => flatFeeTemp.status !== 'D').forEach(flatFeeTemp => {
const _flatFee = ((_work.get('flatFee:' + flatFeeTemp.id) ?? flatFeeTemp) as FlatFee).clone();
_flatFee.status = 'U';
_flatFee.addedOn = newHRTimestamp();
_flatFee.addedBy = getCurrentUserId();
_flatFee.importSource = targetImportSource;
_flatFee.importId = mergeId;
if (_flatFee.relatedTo === contact.id) {
_flatFee.relatedTo = replaceWith.id;

}
_work.set('flatFee:' + _flatFee.id, _flatFee);
store.dispatch(Actions.FlatFeeActions.saveFlatFeeQueue(_flatFee));
});
[...store.getState().leads.getMappingFor('clients', contact.id),
...store.getState().leads.getMappingFor('payers', contact.id),
...store.getState().leads.getMappingFor('referrers', contact.id),].filter(leadTemp => leadTemp.status !== 'D').filter((leadTemp, i, all) => all.findIndex(o => o.id === leadTemp.id) === i).forEach(leadTemp => {
const _lead = ((_work.get('lead:' + leadTemp.id) ?? leadTemp) as Lead).clone();
_lead.status = 'U';
_lead.addedOn = newHRTimestamp();
_lead.addedBy = getCurrentUserId();
_lead.importSource = targetImportSource;
_lead.importId = mergeId;
_lead.clients = _lead.clients?.map(id => (id === contact.id) ? replaceWith.id : id) || [];

_lead.payers = _lead.payers?.map(id => (id === contact.id) ? replaceWith.id : id) || [];

_lead.referrers = _lead.referrers?.map(id => (id === contact.id) ? replaceWith.id : id) || [];

_work.set('lead:' + _lead.id, _lead);
store.dispatch(Actions.LeadActions.saveLeadQueue(_lead));
});
store.getState().participants.getMappingFor('contactId', contact.id).filter(participantTemp => participantTemp.status !== 'D').forEach(participantTemp => {
const _participant = ((_work.get('participant:' + participantTemp.id) ?? participantTemp) as Participant).clone();
_participant.status = 'U';
_participant.addedOn = newHRTimestamp();
_participant.addedBy = getCurrentUserId();
_participant.importSource = targetImportSource;
_participant.importId = mergeId;
if (_participant.contactId === contact.id) {
_participant.contactId = replaceWith.id;

}
_work.set('participant:' + _participant.id, _participant);
store.dispatch(Actions.ParticipantActions.saveParticipantQueue(_participant));
});
store.getState().referrals.getMappingFor('referee', contact.id).filter(referralTemp => referralTemp.status !== 'D').forEach(referralTemp => {
const _referral = ((_work.get('referral:' + referralTemp.id) ?? referralTemp) as Referral).clone();
_referral.status = 'U';
_referral.addedOn = newHRTimestamp();
_referral.addedBy = getCurrentUserId();
_referral.importSource = targetImportSource;
_referral.importId = mergeId;
if (_referral.referee === contact.id) {
_referral.referee = replaceWith.id;

}
_work.set('referral:' + _referral.id, _referral);
store.dispatch(Actions.ReferralActions.saveReferralQueue(_referral));
});
store.getState().tasks.getMappingFor('contactId', contact.id).filter(taskTemp => taskTemp.status !== 'D').forEach(taskTemp => {
const _task = ((_work.get('task:' + taskTemp.id) ?? taskTemp) as Task).clone();
_task.status = 'U';
_task.addedOn = newHRTimestamp();
_task.addedBy = getCurrentUserId();
_task.importSource = targetImportSource;
_task.importId = mergeId;
_task.relatedTo = _task.relatedTo?.map(id => (id === contact.id) ? replaceWith.id : id) || [];

_work.set('task:' + _task.id, _task);
store.dispatch(Actions.TaskActions.saveTaskQueue(_task));
});
store.getState().transactions.getMappingFor('clientIds', contact.id).filter(transactionTemp => transactionTemp.status !== 'D').forEach(transactionTemp => {
const _transaction = ((_work.get('transaction:' + transactionTemp.id) ?? transactionTemp) as Transaction).clone();
_transaction.status = 'U';
_transaction.addedOn = newHRTimestamp();
_transaction.addedBy = getCurrentUserId();
_transaction.importSource = targetImportSource;
_transaction.importId = mergeId;
_transaction.clientIds = _transaction.clientIds?.map(id => (id === contact.id) ? replaceWith.id : id) || [];

_work.set('transaction:' + _transaction.id, _transaction);
store.dispatch(Actions.TransactionActions.saveTransactionQueue(_transaction));
});
store.getState().users.getMappingFor('contactId', contact.id).filter(userTemp => userTemp.status !== 'D').forEach(userTemp => {
const _user = ((_work.get('user:' + userTemp.id) ?? userTemp) as User).clone();
_user.status = 'U';
_user.addedOn = newHRTimestamp();
_user.addedBy = getCurrentUserId();
_user.importSource = targetImportSource;
_user.importId = mergeId;
if (_user.contactId === contact.id) {
_user.contactId = replaceWith.id;

}
_work.set('user:' + _user.id, _user);
store.dispatch(Actions.UserActions.saveUserQueue(_user));
});
findAll<Transaction>('transactions').filter(transactionTemp => ['C','G'].includes(transactionTemp.sourceType || '') && transactionTemp.source === contact.id && transactionTemp.status !== 'D').forEach(transactionTemp => {
const _transaction = ((_work.get('transaction:' + transactionTemp.id) ?? transactionTemp) as Transaction).clone();
_transaction.source = replaceWith.id;
_transaction.status = 'U';
_transaction.addedOn = newHRTimestamp();
_transaction.addedBy = getCurrentUserId();
_transaction.importSource = targetImportSource;
_transaction.importId = mergeId;
_work.set('transaction:' + _transaction.id, _transaction);
store.dispatch(Actions.TransactionActions.saveTransactionQueue(_transaction));
});
findAll<Transaction>('transactions').filter(transactionTemp => ['C','G'].includes(transactionTemp.targetType || '') && transactionTemp.target === contact.id && transactionTemp.status !== 'D').forEach(transactionTemp => {
const _transaction = ((_work.get('transaction:' + transactionTemp.id) ?? transactionTemp) as Transaction).clone();
_transaction.target = replaceWith.id;
_transaction.status = 'U';
_transaction.addedOn = newHRTimestamp();
_transaction.addedBy = getCurrentUserId();
_transaction.importSource = targetImportSource;
_transaction.importId = mergeId;
_work.set('transaction:' + _transaction.id, _transaction);
store.dispatch(Actions.TransactionActions.saveTransactionQueue(_transaction));
});


findAll<Document>('documents').filter(documentTemp => documentTemp.entityType === 'contact' && documentTemp.entityId === contact.id && documentTemp.status !== 'D').forEach(documentTemp => {
const _document = ((_work.get('document:' + documentTemp.id) ?? documentTemp) as Document).clone();
_document.entityId = replaceWith.id;
_document.status = 'U';
_document.addedOn = newHRTimestamp();
_document.addedBy = getCurrentUserId();
_document.importSource = targetImportSource;
_document.importId = mergeId;
_work.set('document:' + _document.id, _document);
store.dispatch(Actions.DocumentActions.saveDocumentQueue(_document));
});
findAll<Comment>('comments').filter(commentTemp => commentTemp.entityType === 'contact' && commentTemp.entityId === contact.id && commentTemp.status !== 'D').forEach(commentTemp => {
const _comment = ((_work.get('comment:' + commentTemp.id) ?? commentTemp) as Comment).clone();
_comment.entityId = replaceWith.id;
_comment.status = 'U';
_comment.addedOn = newHRTimestamp();
_comment.addedBy = getCurrentUserId();
_comment.importSource = targetImportSource;
_comment.importId = mergeId;
_work.set('comment:' + _comment.id, _comment);
store.dispatch(Actions.CommentActions.saveCommentQueue(_comment));
});
findAll<Identification>('identifications').filter(identificationTemp => identificationTemp.entityType === 'contact' && identificationTemp.entityId === contact.id && identificationTemp.status !== 'D').forEach(identificationTemp => {
const _identification = ((_work.get('identification:' + identificationTemp.id) ?? identificationTemp) as Identification).clone();
_identification.entityId = replaceWith.id;
_identification.status = 'U';
_identification.addedOn = newHRTimestamp();
_identification.addedBy = getCurrentUserId();
_identification.importSource = targetImportSource;
_identification.importId = mergeId;
_work.set('identification:' + _identification.id, _identification);
store.dispatch(Actions.IdentificationActions.saveIdentificationQueue(_identification));
});
findAll<Event>('events').filter(eventTemp => eventTemp.entityType === 'contact' && eventTemp.entityId === contact.id && eventTemp.status !== 'D').forEach(eventTemp => {
const _event = ((_work.get('event:' + eventTemp.id) ?? eventTemp) as Event).clone();
_event.entityId = replaceWith.id;
_event.status = 'U';
_event.addedOn = newHRTimestamp();
_event.addedBy = getCurrentUserId();
_event.importSource = targetImportSource;
_event.importId = mergeId;
_work.set('event:' + _event.id, _event);
store.dispatch(Actions.EventActions.saveEventQueue(_event));
});
findAll<Participant>('participants').filter(participantTemp => participantTemp.entityType === 'contact' && participantTemp.entityId === contact.id && participantTemp.status !== 'D').forEach(participantTemp => {
const _participant = ((_work.get('participant:' + participantTemp.id) ?? participantTemp) as Participant).clone();
_participant.entityId = replaceWith.id;
_participant.status = 'U';
_participant.addedOn = newHRTimestamp();
_participant.addedBy = getCurrentUserId();
_participant.importSource = targetImportSource;
_participant.importId = mergeId;
_work.set('participant:' + _participant.id, _participant);
store.dispatch(Actions.ParticipantActions.saveParticipantQueue(_participant));
});
return contact;
}
export function deleteImpactContact(contact: Contact) {
const impacts: string[] = [];
const state = store.getState();
const matterClientsImpact = state.matters.getMappingFor('contactId', contact.id).filter(matter => matter.status !== 'D');
matterClientsImpact.forEach(() => impacts.push('matters*'));
const matterBillToContactIdImpact = state.matters.getMappingFor('billToContactId', contact.id).filter(matter => matter.status !== 'D');
matterBillToContactIdImpact.forEach(() => impacts.push('matters'));
const conflictCheckedContactIdsImpact = state.conflicts.getMappingFor('checkedContactIds', contact.id).filter(conflict => conflict.status !== 'D');
conflictCheckedContactIdsImpact.forEach(() => impacts.push('conflicts'));
const contactCompanyIdImpact = state.contacts.getMappingFor('companyId', contact.id).filter(contact => contact.status !== 'D');
contactCompanyIdImpact.forEach(() => impacts.push('contacts'));
const expensePayeeImpact = state.expenses.getMappingFor('payee', contact.id).filter(expense => expense.status !== 'D');
expensePayeeImpact.forEach(() => impacts.push('expenses'));
const flatFeeRelatedToImpact = state.flatFees.getMappingFor('relatedTo', contact.id).filter(flatFee => flatFee.status !== 'D');
flatFeeRelatedToImpact.forEach(() => impacts.push('flatFees'));
const leadClientsImpact = state.leads.getMappingFor('clients', contact.id).filter(lead => lead.status !== 'D');
leadClientsImpact.forEach(() => impacts.push('leads*'));
const leadPayersImpact = state.leads.getMappingFor('payers', contact.id).filter(lead => lead.status !== 'D');
leadPayersImpact.forEach(() => impacts.push('leads'));
const leadReferrersImpact = state.leads.getMappingFor('referrers', contact.id).filter(lead => lead.status !== 'D');
leadReferrersImpact.forEach(() => impacts.push('leads'));
const participantContactIdImpact = state.participants.getMappingFor('contactId', contact.id).filter(participant => participant.status !== 'D');
participantContactIdImpact.forEach(() => impacts.push('participants*'));
const referralRefereeImpact = state.referrals.getMappingFor('referee', contact.id).filter(referral => referral.status !== 'D');
referralRefereeImpact.forEach(() => impacts.push('referrals'));
const taskRelatedToImpact = state.tasks.getMappingFor('contactId', contact.id).filter(task => task.status !== 'D');
taskRelatedToImpact.forEach(() => impacts.push('tasks'));
const transactionClientIdsImpact = state.transactions.getMappingFor('clientIds', contact.id).filter(transaction => transaction.status !== 'D');
transactionClientIdsImpact.forEach(() => impacts.push('transactions*'));
const userContactIdImpact = state.users.getMappingFor('contactId', contact.id).filter(user => user.status !== 'D');
userContactIdImpact.forEach(() => impacts.push('users'));
const transactionSourceTypeImpact = findAll<Transaction>('transactions').filter(transaction => ['C','G'].includes(transaction.sourceType || '') && transaction.source === contact.id && transaction.status !== 'D');
transactionSourceTypeImpact.forEach(() => impacts.push('transactions'));
const transactionTargetTypeImpact = findAll<Transaction>('transactions').filter(transaction => ['C','G'].includes(transaction.targetType || '') && transaction.target === contact.id && transaction.status !== 'D');
transactionTargetTypeImpact.forEach(() => impacts.push('transactions*'));


return util.countDistinct(impacts);
}
